<script type="text/babel">
export default{
    data () {
        return {
            selected: 'geometry-configuration-1',
            loading: false,
            hideOptionsOnSelect: true,
            optionsVisible: false
        }
    },
    mounted () {
    },
    props: [],
    computed: {},
    methods: {
        setSelected(configuration) {
            this.loading = true;
            this.selected = configuration;
            if (this.hideOptionsOnSelect) {
                this.optionsVisible = false;
            }
            setTimeout(this.clearLoading, 500);

        },
        isSelected(configuration) {
            return this.selected === configuration;
        },
        clearLoading() {
            this.loading = false;
        },
        toggleOptions() {
            this.optionsVisible = !this.optionsVisible;
        }
    }
}
</script>
